import React, { createRef, Fragment } from "react";
import * as style from "./styles.module.scss";

const Checkbox = React.forwardRef(
  (
    {
      label,
      isChecked,
      onClick,
      classes = "",
      name,
      disabled = false,
      validationMessages = [],
      required = false,
    },
    ref = createRef()
  ) => {
    return (
      <Fragment>
        <label
          className={`${style.checkboxInput__label} mr-1 ${classes || ""}`}
        >
          <input
            type="checkbox"
            className={`${style.checkboxInput} mr-1`}
            onChange={onClick}
            checked={isChecked}
            autoComplete="off"
            name={name}
            ref={ref}
            disabled={disabled}
          />
          <span className={style.checkboxInput__checkmark}> </span>
          <label>
            {label}
            {required && "*"}
          </label>
        </label>
        {validationMessages.length > 0 && (
          <span className="text_invalid fontSize-12" style={{ color: "red" }}>
            {validationMessages[0]}
          </span>
        )}
      </Fragment>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
